import { AvField, AvForm } from "availity-reactstrap-validation";
import { withNamespaces } from "react-i18next";
import { Col, Input, Label, Row, Button, Spinner } from "reactstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Accordion } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import AssetDeatilsImage from "src/modules/data-protection/assets/images/basic-info-gdpr.svg";
import { useMutation, useQuery } from "@tanstack/react-query";
import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";
import debounce from "lodash/debounce";
import { useDropzone } from "react-dropzone";
import Dropzone from "react-dropzone";
import { API_BASE_URL } from "../../../../../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import AttachmentCard from "src/modules/data-protection/components/MessageBox/components/AttachmentCard";

const SecondRow = ({
    // General
    t,
    assetId,
    handleFetchSoftwareDetailsQuery,
    // Provider
    selectedProvider,
    setSelectedProvider,
    // Asset Type
    selectedAssetType,
    setSelectedAssetType,
    // Version
    version,
    // Service
    service,
    // Modules
    selectedModules,
    // Responsible Person
    users,
    // Attachments
    attachments,
    // Company
    selectedCompany,
    // Position
    selectedPosition,
    // Phone Number
    selectedPhoneNumber,
    // Email
    selectedEmail,
    // Department
    selectedDepartment,
    // Responsible Person
    selectedResponsiblePerson,

    notice,

    countries,
    selectedHostingLocation,
    setSelectedHostingLocation,
    selectedNoneEUHostingLocation,
    setSelectedNoneEUHostingLocation
}) => {
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [providers, setProviders] = useState([]);
    const [assetTypes, setAssetTypes] = useState([]);
    const [moduleOptions, setModuleOptions] = useState([]);
    const [dragFiles, setDragFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    // Attachments
    const onDrop = useCallback((acceptedFiles) => {
        setDragFiles(acceptedFiles);
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
    });

    const onUploadProgress = (e, file, setUploadedFiles) => {
        const { total, loaded, lengthComputable } = e;

        if (lengthComputable) {
            const uploadedPercent = (loaded / total) * 100;

            setUploadedFiles((uploadedFiles) => {
                const index = uploadedFiles.findIndex(
                    (f) => f.preview === file.preview
                );

                if (index > -1) {
                    uploadedFiles[index].uploadedPercent = uploadedPercent;

                    return [...uploadedFiles];
                }

                return [...uploadedFiles];
            });
        }
    };

    const handleAcceptedFiles = (files, id) => {
        const headers = {
            headers: {},
            onUploadProgress: null,
        };
        const userToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        if (userToken) {
            headers.headers.Authorization = `Bearer ${userToken}`;
        }

        files.map((file) => {
            const formData = new FormData();

            formData.append("file", file);

            file = {
                ...file,
                id: null,
                status: "uploading",
                name: file.name,
                type: file.type,
                questionId: id,
                uploadedPercent: 0,
                preview: URL.createObjectURL(file),
                formattedSize: file.size,
            };

            setUploadedFiles((uploadedFiles) => {
                return [...uploadedFiles, { ...file }];
            });

            axios
                .post(`${API_BASE_URL}/software/${assetId}/add_attachment`, formData, {
                    ...headers,
                    onUploadProgress: (e) => {
                        onUploadProgress(e, file, setUploadedFiles);
                    },
                })
                .then((response) => {
                    setUploadedFiles((uploadedFiles) => {
                        const index = uploadedFiles.findIndex(
                            (f) => f.preview === file.preview
                        );
                        handleFetchSoftwareDetailsQuery();
                        if (index > -1) {
                            if (response.status === 200) {
                                const fileData = response.data.data;

                                uploadedFiles[index].status = "upload_succeed";
                                if (index === files.length - 1) {
                                    toast(t("Files are uploaded successfully"))
                                }

                                uploadedFiles[index].id = fileData.id;
                            } else {
                                uploadedFiles[index].status = "upload_failed";
                            }

                            return [...uploadedFiles];
                        }

                        return [...uploadedFiles];
                    });
                })
                .catch((error) => {
                    toast(t("Error while uploading files"))
                    setUploadedFiles((uploadedFiles) => {
                        const index = uploadedFiles.findIndex(
                            (f) => f.preview === file.preview
                        );

                        if (index > -1) {
                            uploadedFiles[index].status = "upload_failed";

                            return [...uploadedFiles];
                        }

                        return [...uploadedFiles];
                    });

                    toast(t(error?.response?.data?.message), {
                        type: "error",
                    });
                });

        });
    };

    const handleClickDeleteFiles = (file) => {
        const url = `${API_BASE_URL}/software/delete_attachment/${file.id}`;

        const headers = {
            headers: {},
        };

        const userToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        if (userToken) {
            headers.headers.Authorization = `Bearer ${userToken}`;
        }

        setUploadedFiles((uploadedFiles) => {
            const index = uploadedFiles.findIndex((f) => f.id === file.id);

            if (index > -1) {
                uploadedFiles[index].status = "deleting";

                return [...uploadedFiles];
            }

            return [...uploadedFiles];
        });

        axios
            .delete(url, headers)
            .then(() => {
                handleFetchSoftwareDetailsQuery();
                setUploadedFiles([
                    ...uploadedFiles.filter((f) => {
                        return f.id !== file.id;
                    }),
                ]);
                toast("File is removed successfully")
            })
            .catch((error) => {

                setUploadedFiles([
                    ...uploadedFiles.filter((f) => {
                        return f.id !== file.id;
                    }),
                ]);
                toast(t("Error while removing the file"), {
                    type: "error",
                });
            });
    };


    // Modules
    // Fetch
    const handelFetchModulesListQuery = useQuery({
        queryKey: ["data-protection-modules-list", moduleOptions],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();

            const response = await service.modules();
            const data =
                response && response.length
                    ? response.map((r) => ({
                        label: r.name,
                        value: r.id,
                    }))
                    : [];
            setModuleOptions(data);
            return data;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching asset types."), {
                type: "error",
            });
        },
    });

    // Add to mdules
    const handleCreateModuleMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.addModule(payload);
        },
        onSuccess: () => {
            handleFetchSoftwareDetailsQuery();
            handelFetchModulesListQuery.refetch();
            toast(t("New module added successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while adding new module."), {
                type: "error",
            });
        },
    });

    const onCreateModuleOption = (label) => {
        handleCreateModuleMutation.mutate({
            software: Number(assetId),
            module: label,
        });
    };
    // Remove Module
    const handleRemoveModuleMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.removeModule(payload);
        },
        onSuccess: () => {
            handleFetchSoftwareDetailsQuery();
            handelFetchModulesListQuery.refetch();
            toast(t("New module removed successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while removing new module."), {
                type: "error",
            });
        },
    });

    const handleModuleChange = (selectedOptions, actionMeta) => {
        if (actionMeta.action === "remove-value") {
            const { removedValue } = actionMeta;
            handleRemoveModuleMutation.mutate({
                software: Number(assetId),
                module: Number(removedValue?.value),
            });
        } else {
            const { option } = actionMeta;
            handleCreateModuleMutation.mutate({
                software: Number(assetId),
                module: option?.label,
            });
        }
    };

    // Department
    const handleCreateDepartmentMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.changeDepartment(payload);
        },
        onSuccess: () => {
            handleFetchSoftwareDetailsQuery();
            toast(t("Department changed successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while changing department."), {
                type: "error",
            });
        },
    });

    const debouncedHandleDepartmentChange = debounce((event) => {
        const newDepartment = event.target.value;
        handleCreateDepartmentMutation.mutate({
            software: Number(assetId),
            department: newDepartment,
        });
    }, 900);

    // Phone Number
    const handleCreatePhoneNumberMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.changePhoneNumber(payload);
        },
        onSuccess: () => {
            handleFetchSoftwareDetailsQuery();
            toast(t("Phone number changed successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while changing phone number."), {
                type: "error",
            });
        },
    });

    const debouncedHandlePhoneNumberChange = debounce((event) => {
        const newData = event.target.value;
        handleCreatePhoneNumberMutation.mutate({
            software: Number(assetId),
            phoneNumber: newData,
        });
    }, 900);

    // Email
    const handleCreateEmailMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.changeEmail(payload);
        },
        onSuccess: () => {
            handleFetchSoftwareDetailsQuery();
            toast(t("Email changed successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while changing email."), {
                type: "error",
            });
        },
    });

    const debouncedHandleEmailChange = debounce((event) => {
        const newData = event.target.value;
        handleCreateEmailMutation.mutate({
            software: Number(assetId),
            email: newData,
        });
    }, 900);

    // Responsible Person
    const handleCreateResponsiblePersonMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.changeResponsiblePerson(payload);
        },
        onSuccess: () => {
            handleFetchSoftwareDetailsQuery();
            toast(t("Responsible person changed successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while changing responsible person."), {
                type: "error",
            });
        },
    });

    const debouncedHandleResponsiblePersonChange = debounce((event) => {
        handleCreateResponsiblePersonMutation.mutate({
            software: Number(assetId),
            user: String(event.value),
        });
    }, 900);

    // Company
    const handleCompanyMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.changeCompany(payload);
        },
        onSuccess: () => {
            handleFetchSoftwareDetailsQuery();
            toast(t("Company changed successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while changing company."), {
                type: "error",
            });
        },
    });

    const debouncedHandleCompanyChange = debounce((event) => {
        const newData = event.target.value;
        handleCompanyMutation.mutate({
            software: Number(assetId),
            company: newData,
        });
    }, 900);

    // Position
    const handlePositionMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.changePosition(payload);
        },
        onSuccess: () => {
            handleFetchSoftwareDetailsQuery();
            toast(t("Position changed successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while changing position."), {
                type: "error",
            });
        },
    });

    const debouncedHandlePositionChange = debounce((event) => {
        const newData = event.target.value;
        handlePositionMutation.mutate({
            software: Number(assetId),
            position: newData,
        });
    }, 900);

    /**
     * Hosting locations
     */

    const handleCreateEULocationMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.addEULocation(payload);
        },
        onSuccess: () => {
            toast(t("New location added successfully."), {
                type: "success"
            });
        },
        onError: () => {
            toast(t("An error occurred while adding the new location."), {
                type: "error"
            });
        }
    });

    const handleRemoveEULocationMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.removeEULocation(payload);
        },
        onSuccess: () => {
            toast(t("New location added successfully."), {
                type: "success"
            });
        },
        onError: () => {
            toast(t("An error occurred while adding the new location."), {
                type: "error"
            });
        }
    });

    const handleEULocationChange = (selectedOptions, actionMeta) => {
        if (actionMeta.action === "remove-value") {
            const { removedValue } = actionMeta;
            handleRemoveEULocationMutation.mutate({
                software: Number(assetId),
                country: Number(removedValue?.value),
            }, {
                onSuccess: () => {
                    setSelectedHostingLocation((currentState) => {
                        return [
                            ...currentState
                        ].filter((loc) => loc.value !== removedValue.value)
                    })
                }
            });
        } else {
            const { option } = actionMeta;
            handleCreateEULocationMutation.mutate({
                software: Number(assetId),
                country: option?.value,
            }, {
                onSuccess: () => {
                    setSelectedHostingLocation((currentState) => {
                        return [
                            ...currentState,
                            {...option}
                        ]
                    })
                }
            });
        }
    };

    /**
     * None EU hosting locations
     */
    
    const handleCreateNoneEULocationMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.addNoneEULocation(payload);
        },
        onSuccess: () => {
            toast(t("New location added successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while adding new location."), {
                type: "error",
            });
        },
    });

    const handleRemoveNoneEULocationMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.removeNoneEULocation(payload);
        },
        onSuccess: () => {
            toast(t("Location removed successfully."), {
                type: "success"
            });
        },
        onError: () => {
            toast(t("An error occurred while removing location."), {
                type: "error"
            });
        },
    });

    const changeTypeMutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.changeType(payload);
        },
        onSuccess: () => {
            toast(t("Asset type successfully changed."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while updating asset type."), {
                type: "error",
            });
        }
    });

    const handleFetchAssetTypesListQuery = useQuery({
        queryKey: ["data-protection-asset-types-list"],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();

            return await service.types(1000, 1);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching asset types."), {
                type: "error",
            });
        },
    });

    const handleNoneEULocationChange = (selectedOptions, actionMeta) => {
        if (actionMeta.action === "remove-value") {
            const { removedValue } = actionMeta;
            handleRemoveNoneEULocationMutation.mutate({
                software: Number(assetId),
                country: Number(removedValue?.value),
            }, {
                onSuccess: () => {
                    setSelectedNoneEUHostingLocation((currentState) => {
                        return [
                            ...currentState
                        ].filter((loc) => loc.value !== removedValue.value)
                    })
                }
            });
        } else {
            const { option } = actionMeta;
            handleCreateNoneEULocationMutation.mutate({
                software: Number(assetId),
                country: option?.value,
            }, {
                onSuccess: () => {
                    setSelectedNoneEUHostingLocation((currentState) => {
                        return [
                            ...currentState,
                            {...option}
                        ]
                    })
                }
            });
        }
    };

    useEffect(() => {
        if (handelFetchModulesListQuery.data) {
            const gotModules = handelFetchModulesListQuery.data;
            if (gotModules && Array.isArray(gotModules)) {
                setAssetTypes(
                    gotModules.map((gotModule) => {
                        return {
                            label: gotModule,
                            value: gotModule,
                        };
                    })
                );
            }
        }
    }, [handelFetchModulesListQuery.data]);

    return (
        <Accordion className="mt-4" defaultActiveKey={activeAccordion}>
            <Accordion.Item
                onClick={() => setActiveAccordion("asset-details")}
                className={activeAccordion === "asset-details" ? "active" : ""}
                eventKey={"asset-details"}
            >
                <Accordion.Header>
                    <img src={AssetDeatilsImage} alt="" />
                    <span>{t("Asset Details")}</span>
                </Accordion.Header>

                <Accordion.Body>
                    <Row>
                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Software Name")}:</Label>
                            <Input
                                name="softwareName"
                                type="text"
                                className="form-control disabled"
                                value={service}
                                id="softwareName"
                                disabled
                            />
                        </Col>

                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Service Provider")}:</Label>
                            <Input
                                name="serviceProvider"
                                type="text"
                                className="form-control disabled"
                                value={t(selectedProvider?.label)}
                                id="serviceProvider"
                                disabled
                            />
                        </Col>

                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Version")}:</Label>
                            <Input
                                name="version"
                                type="text"
                                className="form-control disabled"
                                value={t(version)}
                                id="version"
                                disabled
                            />
                        </Col>

                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Type")}:</Label>
                            <Input
                                name="asset-type"
                                type="select"
                                className="form-control"
                                value={selectedAssetType || ""}
                                id="asset-type"
                                onChange={(e) => {
                                    const val = e.target.value;
                                    changeTypeMutation.mutate({
                                        software: assetId,
                                        type: e.target.value
                                    }, {
                                        onSuccess: () => {
                                            setSelectedAssetType(val);
                                        }
                                    });
                                }}
                                disabled={changeTypeMutation.isLoading}
                            >
                                {handleFetchAssetTypesListQuery?.data?.map((type) => {
                                    return (
                                        <option key={type} value={type}>
                                            {type}
                                        </option>
                                    );
                                })}
                            </Input>
                            {changeTypeMutation.isLoading && (
                                <>
                                    <Spinner size='sm' color="primary" />
                                    <small className="text-info ms-1">
                                        {t("Changing")}...
                                    </small>
                                </>
                            )}
                        </Col>

                        <Col sm='12' md='6' className='mb-4'>
                            <Label className="form-label">
                                {t("Hosting Location")}:
                            </Label>
                            <CreatableSelect
                                className="mt-1 text-capitalize"
                                placeholder={t("Select") + "..."}
                                options={countries}
                                menuPortalTarget={document.body}
                                isMulti
                                value={selectedHostingLocation}
                                onChange={handleEULocationChange}
                                isClearable={false}
                            />
                        </Col>

                        <Col sm='12' md='6' className='mb-4'>
                            <Label className="form-label">
                                {t("None EU Hosting Location")}:
                            </Label>
                            <CreatableSelect
                                className="mt-1 text-capitalize"
                                placeholder={t("Select") + "..."}
                                options={countries}
                                menuPortalTarget={document.body}
                                isMulti
                                value={selectedNoneEUHostingLocation}
                                onChange={handleNoneEULocationChange}
                                isClearable={false}
                            />
                        </Col>

                        <Col sm="12" md='6' className='mb-4'>
                            <Label className="form-label">{t("Software Module")}:</Label>
                            <CreatableSelect
                                className="mt-1 text-capitalize"
                                placeholder={t("Select") + "..."}
                                options={moduleOptions}
                                menuPortalTarget={document.body}
                                isMulti
                                onCreateOption={onCreateModuleOption}
                                onChange={handleModuleChange}
                                value={selectedModules}
                                isClearable={false}
                            />
                        </Col>

                        <Col sm='12' md='12' className='mb-4'>
                            <Label>{t("Attach Your Files") + ":"}</Label>
                            <Dropzone
                                onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()} className="dropzone tpdd">
                                        <input {...getInputProps()} />
                                        <Button
                                            style={{
                                                background: "#fff",
                                                border: "none",
                                                fontSize: "20px",
                                                paddingRight: 0,
                                            }}
                                            color="#505D69"
                                        >
                                            <i className="ri-attachment-line me-4"></i>
                                        </Button>
                                    </div>
                                )}
                            </Dropzone>

                            {uploadedFiles.length > 0 ? (
                                <Col xs={12} className="p-3">
                                    <div className="d-flex flex-wrap gap-2">
                                        {uploadedFiles.map((file, index) => (
                                            <AttachmentCard
                                                key={index}
                                                attachment={file}
                                                handleClickDeleteFile={handleClickDeleteFiles}
                                                t={t}
                                            />
                                        ))}
                                    </div>
                                </Col>
                            ) : null}
                        </Col>

                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Responsible Person")}:</Label>
                            <Select
                                className="mt-1 text-capitalize"
                                placeholder={t("Select") + "..."}
                                menuPortalTarget={document.body}
                                id="assignedAnalyst"
                                name="assignedAnalyst"
                                isError={handleFetchSoftwareDetailsQuery?.isError}
                                value={selectedResponsiblePerson}
                                options={users}
                                onChange={debouncedHandleResponsiblePersonChange}
                            />
                        </Col>

                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Department")}:</Label>
                            <Input
                                name="department"
                                type="text"
                                className="form-control"
                                onChange={debouncedHandleDepartmentChange}
                                id="department"
                                defaultValue={selectedDepartment}
                            />
                        </Col>

                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Company")}:</Label>
                            <Input
                                name="company"
                                type="text"
                                className="form-control"
                                onChange={debouncedHandleCompanyChange}
                                id="company"
                                defaultValue={selectedCompany}
                            />
                        </Col>

                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Position")}:</Label>
                            <Input
                                name="position"
                                type="text"
                                className="form-control"
                                onChange={debouncedHandlePositionChange}
                                id="position"
                                defaultValue={selectedPosition}
                            />
                        </Col>

                        <Col sm="12" md='3' className='mb-4'>
                            <Label className="form-label">{t("Email")}:</Label>
                            <AvForm>
                                <AvField
                                    name="email"
                                    placeholder=""
                                    type="email"
                                    className="form-control"
                                    validate={{ required: { value: false }, email: true }}
                                    errorMessage={t("This field is invalid")}
                                    id="email"
                                    onChange={debouncedHandleEmailChange}
                                    value={selectedEmail}
                                />
                            </AvForm>
                        </Col>

                        <Col sm="12" md='3'>
                            <Label className="form-label">{t("Phone Number")}:</Label>
                            <AvForm>
                                <AvField
                                    name={`phone`}
                                    errorMessage={t("This field cannot be blank")}
                                    type="number"
                                    onChange={debouncedHandlePhoneNumberChange}
                                    value={selectedPhoneNumber}

                                />
                            </AvForm>
                        </Col>

                        <Col sm='12'>
                            <Label className="form-label">{t("Notice")}:</Label>
                            <AvForm>
                                <AvField
                                    name='notice'
                                    disabled
                                    errorMessage={t("This field cannot be blank")}
                                    type="textarea"
                                    value={notice}
                                />
                            </AvForm>
                        </Col>
                    </Row>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default withNamespaces()(SecondRow);
